<mat-card>
  <mat-card-content>
    <app-data-table *ngIf="response"
      [actions]="actions"
      [columns]="columns"
      [extraParams]="extraParams"
      [dataSource]="dsAvis"
      [filterDisplay]="true"
      [minFilter]="2"
      [flexAction]="5"
      [flexColumn]="90"
      [fontSizeCell]="'0.9em'"
      [pageSize]="10"
      [pageSizesList]="[5,10,25]"
      [placeHolderFilter]="'Rechercher des avis sur nom / prénom'"
      [refreshButton]="false"
      [refreshIcone]="true"
      [showFirstLastButtons]="true"
      [showLoader]="true"
      [loaderMask]="false"
    ></app-data-table>
  </mat-card-content>
</mat-card>
